import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ChevronIcon from 'Component/ChevronIcon';
import { BOTTOM } from 'Component/ChevronIcon/ChevronIcon.config';
import Image from 'Component/Image';
import { STOCK_TYPE } from 'Component/Product/Stock.config';
import ProductAlerts from 'Component/ProductAlerts';
import { ProductType, ProductVariationsItemType } from 'Type/ProductList.type';

import './ProductVariation.style';

/** @namespace PeggysagePwa/Component/ProductVariation/Component */
export class ProductVariationComponent extends PureComponent {
    static propTypes = {
        product: ProductType.isRequired,
        variation: ProductVariationsItemType.isRequired,
        isLimited: PropTypes.bool.isRequired,
        isSelect: PropTypes.bool.isRequired,
        isInCart: PropTypes.bool.isRequired,
        isAlertExpanded: PropTypes.bool.isRequired,
        onClickAlertButton: PropTypes.func.isRequired,
        onClickVariation: PropTypes.func.isRequired
    };

    renderPicture() {
        const {
            variation: {
                variation_thumbnail_url: url
            }
        } = this.props;

        if (!url) {
            return null;
        }

        return (
            <Image
              mix={ { block: 'ProductVariation', elem: 'Picture' } }
              src={ url }
              ratio="custom"
              objectFit="cover"
              isPlaceholder={ !url }
            />
        );
    }

    renderName() {
        const {
            variation: {
                name
            }
        } = this.props;

        return <span block="ProductVariation" elem="Name">{ name }</span>;
    }

    renderAlert() {
        const {
            variation: { stock_status, id: variationProductId },
            isLimited,
            isSelect,
            isAlertExpanded,
            onClickAlertButton
        } = this.props;

        if (isLimited || isSelect || stock_status === STOCK_TYPE.IN_STOCK) {
            return null;
        }

        return (
            <>
                <button
                  block="ProductVariation"
                  elem="AlertButton"
                  onClick={ onClickAlertButton }
                >
                    { __('Créer une alerte') }
                </button>
                <div
                  block="ProductVariation"
                  elem="AlertContent"
                  mods={ { isVisible: isAlertExpanded } }
                >
                    <ProductAlerts
                      productId={ variationProductId }
                      stockStatus={ stock_status }
                    />
                </div>
            </>
        );
    }

    renderLimitedContent() {
        return this.renderPicture();
    }

    renderFullContent() {
        return (
            <>
                { this.renderPicture() }
                { this.renderName() }
            </>
        );
    }

    renderContent() {
        const { isLimited } = this.props;

        if (isLimited) {
            return this.renderLimitedContent();
        }

        return this.renderFullContent();
    }

    renderWrapperLink() {
        const {
            variation: {
                name,
                stock_status
            },
            isInCart,
            isSelect,
            onClickVariation
        } = this.props;

        if (isInCart) {
            return (
                <div
                  block="ProductVariation"
                  elem="Link"
                  mods={ { isOutOfStock: stock_status !== STOCK_TYPE.IN_STOCK } }
                >
                    { this.renderContent() }
                </div>
            );
        }

        return (
            <button
              type="button"
              block="ProductVariation"
              elem="Link"
              title={ name }
              mods={ { isOutOfStock: stock_status !== STOCK_TYPE.IN_STOCK } }
              onClick={ onClickVariation }
            >
                { this.renderContent() }
                { isSelect && <ChevronIcon direction={ BOTTOM } /> }
            </button>
        );
    }

    render() {
        const {
            product: { sku: product_sku },
            variation: { sku },
            isLimited,
            isSelect,
            isInCart
        } = this.props;

        return (
            <div
              block="ProductVariation"
              mods={ {
                  isLimited,
                  isSelect,
                  isInCart,
                  isActive: sku === product_sku
              } }
            >
                { this.renderWrapperLink() }
                { this.renderAlert() }
            </div>
        );
    }
}

export default ProductVariationComponent;
